import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  notification,
  Radio,
  Badge,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import axios from "axios";

const { Option } = Select;

const AddOrUpdateAdmin = (props) => {
  const { visible, onCancel, type, record, refetch } = props;
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const [adminType, setAdminType] = useState('admin');
  const [etablissements, setEtablissements] = useState([]);
  const [fetchingEtablissements, setFetchingEtablissements] = useState(false);

  useEffect(() => {
    if (visible) {
      if (type === "EDIT") {
        form.setFieldsValue({
          name: record.name,
          email: record.email,
          type: record.type,
          status: record.status,
          IdEtab: record?.IdEtab?._id,
        });
        setAdminType(record.type);
      } else {
        form.resetFields();
        setAdminType('admin');
      }
    }
  }, [form, record, visible, type]);

  useEffect(() => {
    if (adminType === 'etablissement' && visible) {
      fetchEtablissements();
    }
  }, [adminType, visible]);

  const fetchEtablissements = async () => {
    setFetchingEtablissements(true);
    try {
      const response = await axios.get("https://trend-me.com/api/Etablissement");
      setEtablissements(response.data);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Impossible de charger la liste des établissements",
      });
    } finally {
      setFetchingEtablissements(false);
    }
  };

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      if (type === "EDIT") {
        await axios.put(`https://trend-me.com/admins/${record._id}`, values);
        notification.success({ message: "Admin modifié avec succès" });
      } else {
        await axios.post("https://trend-me.com/admins", values);
        notification.success({ message: "Admin créé avec succès" });
      }
      refetch();
      onCancel();
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: error.response?.data?.message || "Une erreur est survenue",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTypeChange = (value) => {
    setAdminType(value);
    // Reset IdEtab when switching back to admin
    if (value === 'admin') {
      form.setFieldsValue({ IdEtab: undefined });
    }
  };

  return (
    <Modal
      title={type === "EDIT" ? "Modifier l'admin" : "Ajouter un admin"}
      visible={visible}
      destroyOnClose
      onOk={() => form.submit()}
      confirmLoading={loading}
      onCancel={onCancel}
      width={800}
    >
      <Form
        form={form}
        onFinish={handleFinish}
        layout="vertical"
        initialValues={{
          type: "admin",
          status: "active",
        }}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="name"
              label="Nom complet"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir le nom complet",
                },
              ]}
            >
              <Input placeholder="Entrez le nom complet" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Veuillez saisir un email valide",
                },
              ]}
            >
              <Input placeholder="Entrez l'email" />
            </Form.Item>
          </Col>

          {type !== "EDIT" && (
            <Col span={24}>
              <Form.Item
                name="password"
                label="Mot de passe"
                rules={[
                  {
                    required: true,
                    message: "Veuillez saisir un mot de passe",
                  },
                  {
                    min: 6,
                    message: "Le mot de passe doit contenir au moins 6 caractères",
                  },
                ]}
              >
                <Input.Password placeholder="Entrez le mot de passe" />
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <Form.Item
              name="type"
              label="Type"
              rules={[
                {
                  required: true,
                  message: "Veuillez sélectionner le type",
                },
              ]}
            >
              <Select onChange={handleTypeChange}>
                <Option value="admin">Administrateur</Option>
                <Option value="etablissement">Etablissement</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="status"
              label="Statut"
              rules={[
                {
                  required: true,
                  message: "Veuillez sélectionner le statut",
                },
              ]}
            >
              <Radio.Group>
                <Radio value="active">
                  <Badge status="success" text="Actif" />
                </Radio>
                <Radio value="inactive">
                  <Badge status="error" text="Inactif" />
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          {adminType === 'etablissement' && (
            <Col span={24}>
              <Form.Item
                name="IdEtab"
                label="Etablissement"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un établissement",
                  },
                ]}
              >
                <Select
                  placeholder="Sélectionnez un établissement"
                  loading={fetchingEtablissements}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {etablissements.map((etab) => (
                    <Option key={etab._id} value={etab._id}>
                      {etab.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default AddOrUpdateAdmin;